import React, { useEffect, useState, useRef } from "react";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import FacilityInformation from "./FacilityInformation";
import AccessiblePermission from "./AccessiblePermission";
import FTPPermission from "./FTPPermission";
import FinancialSetup from "./FinancialSetup";
import SecuritySetup from "./SecuritySetup";
import AllowableURL from "./AllowableURL";
import LockKIOSKS from "./LockKIOSKS";
import { useDispatch, useSelector } from "react-redux";
import {
  facilitySchema,
  inmateRequestForm,
  MGUserFormPermission,
  CommissaryFillAll,
  KISOKRestrict,
} from "../../validation/facilitySchema";
import FacilityForms from "./FacilityForms";
import FacilityFreeCredit from "./FacilityFreeCredit";
import FacilityWebService from "./FacilityWebService";
import ConnectionRequestSetup from "./ConnectionRequestSetup";
import { authActions, facilityAction } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import { encryptData } from "../../utils/encryptDecrypt";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { DaysFlag, StoredProcedures } from "../../_helpers/enumerator";
import { decryptData } from "../../utils/encryptDecrypt";
import { getStoredValue, removeStoredValue } from "../../_helpers/storagehelper";

function AddOrEditFacility() {
  const dispatch = useDispatch();
  const location = useLocation();
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const initialFacilityData = useSelector(
    (x) => x?.facility?.initialFacilityData
  );
  const facilityDetails = useSelector((x) => x?.facility?.facilityDetails);
  const [isloading, setisloading] = useState(false);
  const DaysListData = useSelector((x) => x?.facility?.DaysListData);
  const InmateForm = useSelector((x) => x?.facility?.InmateForm);
  const ManagementForm = useSelector((x) => x?.facility?.ManagementForm);
  const FormsDetails = useSelector((x) => x?.facility?.FormsDetails);
  const [editedFacilityInformationData, setEditedFacilityInformationData] =
    useState(initialFacilityData);
  const fileInputRef = useRef();
  // Getting user details
  const { user } = useSelector((x) => x.auth);
  const addFacilityResponse = useSelector(
    (x) => x?.facility?.addFacilityResponse
  );
  const facilityID = location?.state ? location?.state?.facilityID : 0;

  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);

  const facilityIDForPrePopulate =
    process.env.REACT_APP_PREPOPULATE_FROM_FACILITYID;
  const facilityCodeForPrePopulate =
    process.env.REACT_APP_PREPOPULATE_FROM_FACILITYCODE;

  useEffect(() => {
    dispatch(facilityAction?.resetForm());
  }, []);

  useEffect(() => {
    setSubmit(addFacilityResponse?.loading ? true : false);
    switch (addFacilityResponse.IsSucceed) {
      case 0:
        showToastNotification("Failed to create Facility", "error");
        break;

      case 1:
        //dispatch(facilityAction.resetFacilitySearch());
        showToastNotification(
          "Facility information saved successfully",
          "success"
        );
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: facilityInformationData?.FacilityID,
            ProcedureName: StoredProcedures?.FacilityCPU,
            UserAction: `Created a New Facility (FacilityCode - ${facilityInformationData?.FacilityCode})`,
          })
        );
        history.navigate("/Admin/FacilityList/");
        dispatch(facilityAction?.resetForm());
        break;

      case 2:
        showToastNotification(
          "Facility information updated successfully.",
          "success"
        );
        //dispatch(facilityAction.resetFacilitySearch());
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: facilityInformationData?.FacilityID,
            ProcedureName: StoredProcedures?.FacilityCPU,
            UserAction: `Updated Details in Facility (Facility ID - ${facilityInformationData?.FacilityID})`,
          })
        );
        history.navigate("/Admin/FacilityList/");
        dispatch(facilityAction?.resetForm());
        break;

      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "warning"
        );
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      case -2:
        showToastNotification("The email already exists", "error");
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      case -3:
        showToastNotification("The facility name already exists", "error");
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      case -4:
        showToastNotification("The facility code already exists", "error");
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      case -5:
        showToastNotification("The FTP file path already exists", "error");
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      case -6:
        showToastNotification(
          "A quarantine word is already created for this facility. To disable quarantine, update the quarantine word to 'No Flag' status",
          "error"
        );
        dispatch(facilityAction?.resetFacilityFormResponse());
        break;

      default:
        break;
    }
  }, [addFacilityResponse]);

  useEffect(() => {
    if (facilityID > 0) {
      getFacilityDetails();
    }
  }, [facilityID]);

  const generateRandomString = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const getFacilityDetails = async (prePopulate) => {
    const facilityData = { ...facilityInformationData };
    setErrorMessage({});
    if (prePopulate) {
      facilityData.PrePopulate = true;
      dispatch(facilityAction?.setFacilityData(facilityData));
    }
    await dispatch(
      facilityAction.GetFacilityDetailsByID({
        facilityID: prePopulate ? prePopulate : facilityID,
      })
    )
      .then((result) => {
        const response = result?.payload;
        const facilityUpdatedData = { ...response };
        let CommissaryAccessInterval = [
          ...initialFacilityData.Type_CommissaryAccessInterval,
        ];
        CommissaryAccessInterval = CommissaryAccessInterval.map((data) => {
          return {
            ...data,
            FacilityID: facilityID,
          };
        });
        response?.Type_CommissaryAccessInterval?.forEach((item) => {
          //if (item.ActiveStatus !== 0) {
          const modifiedItem = {
            ...item,
            KioskCommissaryAccessID: 0,
            isEnable:
              item?.AccessFromTime === "00:00" && item?.AccessToTime === "00:00"
                ? false
                : true,
            AccessFromTime:
              item?.AccessFromTime === "00:00" && item?.AccessToTime === "00:00"
                ? ""
                : item?.AccessFromTime,
            AccessToTime:
              item?.AccessToTime === "00:00" && item?.AccessFromTime === "00:00"
                ? ""
                : item?.AccessToTime,
            ActiveStatus: item.ActiveStatus,
          };

          CommissaryAccessInterval = CommissaryAccessInterval.map((data) => {
            if (
              data.WeekDayNumber === item.WeekDayNumber &&
              item.ActiveStatus !== 0
            ) {
              return {
                ...data,
                ...modifiedItem,
              };
            }
            return data;
          });
          // }
        });

        const updateKioskRestrictInterval =
          response?.Type_KioskRestrictInterval?.map((item) => {
            // if (item.ActiveStatus !== 0) {
            return {
              ...item,
              RandomID: generateRandomString(10),
            };
            // }
            // return null;
          }).filter((item) => item !== null);

        facilityUpdatedData.Type_CommissaryAccessInterval =
          CommissaryAccessInterval;
        facilityUpdatedData.Type_KioskRestrictInterval =
          updateKioskRestrictInterval;
        facilityUpdatedData.getLockKIOSKDetails = true;
        facilityUpdatedData.getInmateFormDetails = true;
        facilityUpdatedData.FacilityMessageCost =
          facilityUpdatedData.FacilityMessageCost > 0
            ? facilityUpdatedData.FacilityMessageCost.toFixed(2)
            : "";
        facilityUpdatedData.FacilityPhotoCost =
          facilityUpdatedData.FacilityPhotoCost > 0
            ? facilityUpdatedData.FacilityPhotoCost.toFixed(2)
            : "";
        facilityUpdatedData.FacilityEcardCost =
          facilityUpdatedData.FacilityEcardCost > 0
            ? facilityUpdatedData.FacilityEcardCost.toFixed(2)
            : "";
        facilityUpdatedData.FacilityEmojiCost =
          facilityUpdatedData.FacilityEmojiCost > 0
            ? facilityUpdatedData.FacilityEmojiCost.toFixed(2)
            : "";
        facilityUpdatedData.InmateInvitePublicCount =
          facilityUpdatedData.InmateInvitePublicCount > 0
            ? facilityUpdatedData.InmateInvitePublicCount
            : "";
        facilityUpdatedData.InmateInvitePublicRepeatLimit =
          facilityUpdatedData.InmateInvitePublicRepeatLimit > 0
            ? facilityUpdatedData.InmateInvitePublicRepeatLimit
            : "";
        facilityUpdatedData.FTPPassword = facilityUpdatedData?.FTPPassword
          ? decryptData(facilityUpdatedData?.FTPPassword)
          : "";
        if (prePopulate) {
          const fieldsToClear = [
            { key: "FacilityName", value: facilityData?.FacilityName },
            { key: "FacilityCode", value: facilityData?.FacilityCode },
            { key: "Email", value: facilityData?.Email },
            { key: "Address1", value: facilityData?.Address1 },
            { key: "Address2", value: facilityData?.Address2 },
            { key: "City", value: facilityData?.City },
            { key: "ZIP", value: facilityData?.ZIP },
            { key: "StateNameID", value: facilityData?.StateNameID },
            { key: "PhoneNumber", value: facilityData?.PhoneNumber },
            {
              key: "IsQuarantineWordBlock",
              value: facilityData?.IsQuarantineWordBlock,
            },
            { key: "CactasURL", value: facilityData?.CactasURL },
            { key: "CactasAccessKey", value: facilityData?.CactasAccessKey },
            { key: "FTPServerURL", value: facilityData?.FTPServerURL },
            { key: "FTPPassword", value: facilityData?.FTPPassword },
            { key: "FTPFilePath", value: facilityData?.FTPFilePath },
            { key: "FTPUserName", value: facilityData?.FTPUserName },
            { key: "ActiveStatus", value: facilityData?.ActiveStatus },
            { key: "file", value: facilityData?.file },
            { key: "filename", value: facilityData?.filename },
            { key: "folderPath", value: facilityData?.folderPath },
            { key: "LogoFile", value: facilityData?.LogoFile },
          ];
          fieldsToClear?.forEach((item) => {
            if (facilityUpdatedData?.hasOwnProperty(item.key)) {
              facilityUpdatedData[item.key] = item.value;
            }
          });
          facilityUpdatedData["logoImage"] = facilityData?.logoImage;
          facilityUpdatedData["base64Data"] = facilityData?.base64Data;
          facilityUpdatedData["LogoFilePath"] = facilityData?.LogoFilePath;
        }
        facilityUpdatedData.PrePopulate = true;
        setEditedFacilityInformationData(facilityUpdatedData);
        dispatch(facilityAction?.setFacilityData(facilityUpdatedData));
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const escapeSelector = (selector) => {
    return selector
      .replace(/([.#])/g, "\\$1")
      .replace(/\[/g, "\\[")
      .replace(/\]/g, "\\]");
  };

  const handleFacilityForm = async (e) => {
    e?.preventDefault();
    setSubmit(true);
    const validationErrors = await validate();
    setErrorMessage(validationErrors);
    if (Object.keys(validationErrors).length !== 0) {
      const firstErrorField = Object.keys(validationErrors)[0];
      if (firstErrorField) {
        const escapedName = escapeSelector(firstErrorField);
        let field = document.querySelector(`[name=${escapedName}]`);
        if (field && field.type !== "hidden") {
          field.focus();
        } else {
          field = document.querySelector(`#${escapedName}`);
          if (field) {
            if (field instanceof HTMLDivElement && field.tabIndex === -1) {
              field.tabIndex = 0;
            }
            field.focus();
          }
        }
      }
      setSubmit(false);
      const allErrorsMatch = Object.values(validationErrors).every(
        (error) => error === "Repeated Time Intervals."
      );
      if (allErrorsMatch) {
        Popup({
          title: "Message",
          text: `Please correct the errors in lock down kiosks.`,
          icon: "info",
          confirmButtonText: "Ok",
        });
      }
      return;
    }
    const facilityData = { ...facilityInformationData };
    if (
      facilityData["Type_RequestFormPermission"]?.length === 0 &&
      facilityData["Type_RequestMGUserFormPermission"]?.length === 0 &&
      facilityData?.IsFormReqAccess === 1
    ) {
      Popup({
        title: "Message",
        text: `Please add request forms.`,
        icon: "info",
        confirmButtonText: "Ok",
      });
      setSubmit(false);
      return;
    }

    if (
      facilityData["Type_RequestFormPermission"]?.length > 0 &&
      facilityData?.IsFormReqAccess === 1
    ) {
      const isPDSCrispActive = facilityData["Type_RequestFormPermission"].some(
        (item) =>
          item.RequestFormType === "Public Defender Services - Crisp" &&
          item.ActiveStatus === 1
      );
      const isPDSActive = facilityData["Type_RequestFormPermission"].some(
        (item) =>
          item.RequestFormType === "Public Defender Services" &&
          item.ActiveStatus === 1
      );
      if (isPDSCrispActive && isPDSActive) {
        Popup({
          title: "Message",
          text: `Cannot activate both PDS forms at the same time.`,
          icon: "info",
          confirmButtonText: "Ok",
        });
        setSubmit(false);
        return;
      }
    }
    const encryptPassword = encryptData(facilityData?.FTPPassword);
    facilityData["FTPPassword"] = encryptPassword;
    facilityData["createdBy"] = getStoredValue("user")?.ManagementUserID || 0;
    if (facilityID > 0) {
      setisloading(true);
      dispatch(facilityAction?.updateFacility(facilityData)).then((x) => { setisloading(false) });
    } else {
      setisloading(true);
      dispatch(facilityAction?.addFacility(facilityData)).then((x) => { setisloading(false) })
      removeStoredValue("facilityDropDown");
    }
  };

  const validate = async () => {
    let UpdatedFacilityData = { ...facilityInformationData, IsEcardAccess: facilityInformationData?.IsEcardAccess == null ? 0 : facilityInformationData?.IsEcardAccess };
    const validationErrors = {};
    try {
      await facilitySchema.validateAsync(UpdatedFacilityData, {
        abortEarly: false,
        errors: {
          label: "key", // This will display the key in error messages (instead of just the error message).
        },
      });
    } catch (err) {
      err.details.forEach((error) => {
        const field = error?.path[0]; // Get the actual field name from the error path
        validationErrors[field] = error.message; // Use the correct field name
      });
    }
    if (UpdatedFacilityData?.IsCommissaryAccess === 1) {
      UpdatedFacilityData["Type_CommissaryAccessInterval"] =
        UpdatedFacilityData["Type_CommissaryAccessInterval"]
          .map((item, i) => {
            const Items = { ...item };
            const clonedItem = {};

            // Add new dynamic properties to match Joi schema
            clonedItem[
              `Type_CommissaryAccessInterval.${Items.WeekDayNumber}.AccessFromTime`
            ] = Items.AccessFromTime;
            clonedItem[
              `Type_CommissaryAccessInterval.${Items.WeekDayNumber}.AccessToTime`
            ] = Items.AccessToTime;
            clonedItem[`isEnable`] = Items.isEnable;
            clonedItem[`WeekDayNumber`] = Items.WeekDayNumber;

            // Only push when Items.isEnable is true
            if (Items.isEnable) {
              return clonedItem;
            } else {
              // Return undefined to filter out the item when isEnable is false
              return undefined;
            }
          })
          .filter((item) => item !== undefined); // Remove undefined items

      const { error } = CommissaryFillAll({
        CommissaryFillAll: UpdatedFacilityData["Type_CommissaryAccessInterval"],
      });
      if (error?.details) {
        error.details.forEach((error) => {
          const field =
            error?.path?.length === 1 ? error?.path[0] : error?.path[2]; // Get the actual field name from the error path
          validationErrors[field] = error.message; // Use the correct field name
        });
      }
    }

    if (UpdatedFacilityData?.IsFormReqAccess === 1) {
      // Map the form items to match the schema format
      UpdatedFacilityData["Type_RequestFormPermission"] = UpdatedFacilityData[
        "Type_RequestFormPermission"
      ].map((item, i) => {
        const Items = { ...item };
        const clonedItem = {};
        const requestFormTypeID = Items.RequestFormTypeID;
        // Add new dynamic properties to match Joi schema
        clonedItem[
          `Type_RequestFormPermission.${requestFormTypeID}.FacilityRequestFormTitle`
        ] = Items.FacilityRequestFormTitle;

        return clonedItem;
      });
      UpdatedFacilityData["Type_RequestMGUserFormPermission"] =
        UpdatedFacilityData["Type_RequestMGUserFormPermission"].map(
          (item, i) => {
            const Items = { ...item };
            const clonedItem = {};
            const requestFormTypeID = Items.RequestFormTypeID;
            // Add new dynamic properties to match Joi schema
            clonedItem[
              `Type_RequestMGUserFormPermission.${requestFormTypeID}.FacilityRequestFormTitle`
            ] = Items.FacilityRequestFormTitle;

            return clonedItem;
          }
        );
      const { error: error1 } = inmateRequestForm({
        Type_RequestFormPermission:
          UpdatedFacilityData["Type_RequestFormPermission"],
      });
      const { error: error2 } = MGUserFormPermission({
        Type_RequestMGUserFormPermission:
          UpdatedFacilityData["Type_RequestMGUserFormPermission"],
      });

      if (error1?.details) {
        error1.details.forEach((error) => {
          const field =
            error?.path?.length === 1 ? error?.path[0] : error?.path[2]; // Get the actual field name from the error path
          validationErrors[field] = error.message; // Use the correct field name
        });
      }

      if (error2?.details) {
        error2.details.forEach((error) => {
          const field =
            error?.path?.length === 1 ? error?.path[0] : error?.path[2]; // Get the actual field name from the error path
          validationErrors[field] = error.message; // Use the correct field name
        });
      }
    }

    const weekDays = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    // Loop through all days dynamically
    weekDays.forEach((day) => {
      if (DaysListData[day]?.length > 0) {
        const { error } = KISOKRestrict({
          kioskRestrictIntervalFillAll: DaysListData[day],
        });
        if (error?.details) {
          error?.details?.map((e) => {
            const { path } = e;
            const weekDayIndex = path[1];
            const field = path[2];
            const formattedPath = `kioskRestrictIntervalFillAll[${DaysListData[day][weekDayIndex]?.WeekDayNumber}].[${weekDayIndex}].${field}`;
            validationErrors[formattedPath] = e?.message;
          });
        }
      }
    });
    return validationErrors;
  };

  const preFetchData = () => {
    //if (facilityInformationData?.PrePopulate) return;
    Popup({
      title: "Message",
      text: `Are you sure, you want to fill facility Informations from .${facilityCodeForPrePopulate} Facility ?`,
      icon: "info",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => getFacilityDetails(facilityIDForPrePopulate),
    });
    return;
  };

  const handleNavigate = () => {
    history.navigate("FacilityList");
    dispatch(facilityAction?.resetForm());
  };

  const handleReset = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear file input
    }
    setErrorMessage({});
    let updatedFormList = { ...FormsDetails };
    if (ManagementForm?.length > 0) {
      const updatedManagementForm = ManagementForm.map((items) => {
        return {
          ...items,
          isActive:
            facilityID > 0 &&
              editedFacilityInformationData["Type_RequestMGUserFormPermission"]
                ?.length > 0
              ? editedFacilityInformationData[
                "Type_RequestMGUserFormPermission"
              ].some(
                (item) => item.RequestFormTypeID === items.RequestFormTypeID
              )
              : false,
        };
      });
      const allActive = updatedManagementForm.every(
        (item) => item.isActive === true
      );
      const checkManagementRequestForm = ManagementForm?.map((items) => {
        return {
          ...items,
          isActive:
            facilityID > 0 &&
              editedFacilityInformationData["Type_RequestMGUserFormPermission"]
                ?.length > 0
              ? editedFacilityInformationData[
                "Type_RequestMGUserFormPermission"
              ].some(
                (item) => item.RequestFormTypeID === items.RequestFormTypeID
              )
              : false,
        };
      });
      updatedFormList.isManagementSelectAll = allActive;
      updatedFormList.managementRequestForm = updatedManagementForm;
      updatedFormList.checkManagementRequestForm = checkManagementRequestForm;
    }

    if (InmateForm?.length > 0) {
      const updatedInmateForm = InmateForm.map((items) => {
        return {
          ...items,
          isActive:
            facilityID > 0 &&
              editedFacilityInformationData["Type_RequestFormPermission"]
                ?.length > 0
              ? editedFacilityInformationData[
                "Type_RequestFormPermission"
              ].some(
                (item) => item.RequestFormTypeID === items.RequestFormTypeID
              )
              : false,
        };
      });
      const allActive = updatedInmateForm.every(
        (item) => item.isActive === true
      );
      const checkInmateRequestForm = InmateForm?.map((items) => {
        return {
          ...items,
          isActive:
            facilityID > 0 &&
              editedFacilityInformationData["Type_RequestFormPermission"]
                ?.length > 0
              ? editedFacilityInformationData[
                "Type_RequestFormPermission"
              ].some(
                (item) => item.RequestFormTypeID === items.RequestFormTypeID
              )
              : false,
        };
      });
      updatedFormList.isInmateSelectAll = allActive;
      updatedFormList.inmateRequestForm = updatedInmateForm;
      updatedFormList.checkInmateRequestForm = checkInmateRequestForm;
    }
    dispatch(facilityAction.setFormsDetails(updatedFormList));
    UpdatedKioskList(
      editedFacilityInformationData["Type_KioskRestrictInterval"]
    );

    let UpdatedFacilityInformationData = {
      ...editedFacilityInformationData,
      PrePopulate: false,
    };
    if (facilityID > 0) {
      dispatch(facilityAction?.setFacilityData(UpdatedFacilityInformationData));
    } else {
      dispatch(facilityAction?.resetForm());
    }
  };

  const UpdatedKioskList = (Type_KioskRestrictInterval) => {
    let UpdatedDaysListData = { ...DaysListData };
    const sundayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 1
    );
    const mondayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 2
    );
    const tuesdayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 3
    );
    const wednesdayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 4
    );
    const thursdayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 5
    );
    const fridayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 6
    );
    const saturdayData = Type_KioskRestrictInterval.filter(
      (item) => item?.WeekDayNumber === 7
    );

    if (sundayData?.length > 0) {
      UpdatedDaysListData.sunday = sundayData;
      UpdatedDaysListData.sundayCheckbox = true;
    } else {
      UpdatedDaysListData.sunday = [];
      UpdatedDaysListData.sundayCheckbox = false;
    }
    if (mondayData?.length > 0) {
      UpdatedDaysListData.monday = mondayData;
      UpdatedDaysListData.mondayCheckbox = true;
    } else {
      UpdatedDaysListData.monday = [];
      UpdatedDaysListData.mondayCheckbox = false;
    }
    if (tuesdayData?.length > 0) {
      UpdatedDaysListData.tuesday = tuesdayData;
      UpdatedDaysListData.tuesdayCheckbox = true;
    } else {
      UpdatedDaysListData.tuesday = [];
      UpdatedDaysListData.tuesdayCheckbox = false;
    }
    if (wednesdayData?.length > 0) {
      UpdatedDaysListData.wednesday = wednesdayData;
      UpdatedDaysListData.wednesdayCheckbox = true;
    } else {
      UpdatedDaysListData.wednesday = [];
      UpdatedDaysListData.wednesdayCheckbox = false;
    }
    if (thursdayData?.length > 0) {
      UpdatedDaysListData.thursday = thursdayData;
      UpdatedDaysListData.thursdayCheckbox = true;
    } else {
      UpdatedDaysListData.thursday = [];
      UpdatedDaysListData.thursdayCheckbox = false;
    }
    if (fridayData?.length > 0) {
      UpdatedDaysListData.friday = fridayData;
      UpdatedDaysListData.fridayCheckbox = true;
    } else {
      UpdatedDaysListData.friday = [];
      UpdatedDaysListData.fridayCheckbox = false;
    }
    if (saturdayData?.length > 0) {
      UpdatedDaysListData.saturday = saturdayData;
      UpdatedDaysListData.saturdayCheckbox = true;
    } else {
      UpdatedDaysListData.saturday = [];
      UpdatedDaysListData.saturdayCheckbox = false;
    }
    dispatch(facilityAction.setDaysListData(UpdatedDaysListData));
  };


  return (
    <>
      {(facilityDetails?.loading || isloading) && <CustomLoader />}
      <div className="add-facility">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
              <h2 className="form_title_uppercase text-color">
                {facilityID > 0 ? "EDIT FACILITY" : "ADD FACILITY"}
              </h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                {facilityID === 0 && (
                  <Button
                    variant="success"
                    className="me-2"
                    label={"Pre-Populate From  " + facilityCodeForPrePopulate}
                    type="button"
                    status="btn-label"
                    icon={"fa-solid fa-file-invoice"}
                    //disabled={facilityInformationData?.PrePopulate}
                    onClick={preFetchData}
                  />
                )}

                <Button
                  label="Back"
                  type="button"
                  status="primary"
                  icon={"fa-solid fa-angle-left"}
                  onClick={() => {
                    handleNavigate();
                  }}
                />
              </div>
            </div>

            <form className="w-100">
              <FacilityInformation
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                fileInputRef={fileInputRef}
              />
              <AccessiblePermission
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
              />

              {(facilityInformationData?.IsInmateCactasCredit ||
                facilityInformationData?.InmateUploadType === 2) && (
                  <FacilityWebService
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                )}
              {facilityInformationData?.InmateUploadType === 1 && (
                <FTPPermission
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                />
              )}

              <FinancialSetup
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
              />
              <SecuritySetup errorMessage={errorMessage} />
              {facilityInformationData?.IsInmateFreeCredit === 1 && (
                <FacilityFreeCredit
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                />
              )}
              {facilityInformationData?.IsInmateInvitePublic == 1 && (
                <ConnectionRequestSetup
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                />
              )}
              <AllowableURL
                errorMessage={errorMessage}
                setError={setErrorMessage}
              />
              <FacilityForms
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
              />
              {/* {facilityInformationData?.Type_KioskRestrictInterval > 0 && (
          )} */}
              <LockKIOSKS
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                generateRandomString={generateRandomString}
              />
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Button
                  label={facilityID > 0 ? "UPDATE" : "SAVE"}
                  status="success"
                  type="button"
                  onClick={(e) => handleFacilityForm(e)}
                  icon={
                    facilityID > 0
                      ? "fa-solid fa-pen-to-square"
                      : "fa-solid fa-floppy-disk"
                  }
                  disabled={submit}
                />
                <Button
                  label="RESET"
                  icon={"fa-solid fa-rotate-right"}
                  onClick={handleReset}
                  status="secondary"
                  type="button"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(AddOrEditFacility);
